import AuthManager from "Common/AuthManager";
import { toast } from "react-toastify";
import ServiceWrapper from "Services/ServiceWrapper";
import AppSettings from "Settings/AppSettings";

const api_base_url = AppSettings.GMS_BACKEND_API_URL;

export const fetchIterationTableData = async (industryId: string, channelKey: string, page: number, recordPerPage: number, sort_by: IterationSortOption, sort_order: 1 | -1) => {
    try {
        const params = new URLSearchParams({
            page: page.toString(),
            limit: recordPerPage.toString(),
            sort_by: sort_by,
            sort_order: sort_order.toString()
        });

        const res = await ServiceWrapper.doGet(
            `${api_base_url}iteration-substitution/${industryId}/${channelKey}?${params.toString()}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        if (!res.errorfound) {
            return res.data;
        } else return null;
    } catch (error) {
        return "could'nt get pivot attributes";
    }
};

export const deleteIterationMethod = async (iterationId: string) => {
    try {
        const res = await ServiceWrapper.doDelete(
            `${api_base_url}iteration-substitution/${iterationId}`,
            null,
            null,
            AuthManager.getGmsToken()
        );

        return res?.data;
    } catch (error) {
        toast.warning("Delete Unsuccessful");
        return "Delete Unsuccessful";
    }
};

export const getIterationMethod = async (id: string) => {
    try {
        const ret = await ServiceWrapper.doGet(
            `${api_base_url}iteration-substitution/${id}`,
            null,
            null,
            AuthManager.getGmsToken()
        );

        if (!ret.errorfound) {
            return ret?.data?.data;
        } else return ret?.data?.message;
    } catch (error) {
        return "could'nt get the iteration data";
    }
};

export const updateIterationMethod = async (data: CategoryData) => {
    try {
        const response = await ServiceWrapper.doPut(
            `${api_base_url}iteration-substitution/${data?.id}`,
            data,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        return error;
    }
}

export const createIterationMethod = async (channelKey: string, industryId: string, categoryId: string, categoryName: string) => {
    try {
        const response = await ServiceWrapper.doPost(
            `${api_base_url}iteration-substitution`,
            {
                "channel_key": channelKey,
                "industry_id": industryId,
                "category_id": categoryId,
                "category_name": categoryName
            },
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        return error;
    }
}

export const getAttributeValues = async (attributeId: string, page: number, searchString = '') => {
    try {
        const res = await ServiceWrapper.doPost(
            `${api_base_url}get_attribute_values?page=${page}&limit=10&search=${searchString}`,
            { attribute_ids: [attributeId] },
            null,
            AuthManager.getGmsToken()
        );
        if (!res.errorfound) {
            return res.data;
        } else return null;
    } catch (error) {
        return error;
    }
};